<script>
  import { onMount } from 'svelte';
  import { platform, isPWAInstalled } from './BrowserDetector.svelte';
 
  export let antalTecken;
  export let formatCurrencySEK;
  export let footerLabels;

  onMount(() => {
    document.documentElement.style.setProperty('--footerBottom', '0pt');
    document.documentElement.style.setProperty('--footerMobileHeight', '25pt');
    document.documentElement.style.setProperty('--drawerBottom', '31pt');
    document.documentElement.style.setProperty('--drawerHeight', '84pt');
    if ( ($platform === 'iOS' || $platform === 'Android') && $isPWAInstalled === true ) {
      document.documentElement.style.setProperty('--footerBottom', '3pt');
      document.documentElement.style.setProperty('--footerMobileHeight', '30pt');
      document.documentElement.style.setProperty('--drawerBottom', '34pt');
      document.documentElement.style.setProperty('--drawerHeight', '89pt');
    }
  });

</script>



<div class="footer">
  <div class="footerInfo">
    <div class="footerInfoSection">
      <img src="/images/enkel.svg" alt="{footerLabels[0]}" title="{footerLabels[0]}" /> {antalTecken[0]}
      <br />
      <span>{footerLabels[0]}</span>
    </div>
    <div class="footerInfoSection">
      <img src="/images/halv.svg" alt="{footerLabels[1]}" title="{footerLabels[1]}" /> {antalTecken[1]}
      <br />
      <span>{footerLabels[1]}</span>
    </div>
    <div class="footerInfoSection">
      <img src="/images/hel.svg" alt="{footerLabels[2]}" title="{footerLabels[2]}" /> {antalTecken[2]}
      <br />
      <span>{footerLabels[2]}</span>
    </div>
    <div class="footerInfoSection">
      <img src="/images/oreducerat.svg" alt="{footerLabels[3]}" title="{footerLabels[3]}" /> {formatCurrencySEK(antalTecken[3],true,false)}
      <br />
      <span>{footerLabels[3]}</span>
    </div>
  </div>
</div>

<style>
  /* Footer styles */

.footer {
  z-index: 30;
  grid-column: 1 / -1; /* Spans both columns */
/*   background-color: #333; */
  background-color: var(--themeColor1);
  color: white;
  text-align: center;
  padding: 5pt 5pt 5pt 5pt;

/*   padding: 0px; */
/*   padding-bottom: 10px; */
  position: sticky;
  height: 40pt;
  width: 100%;
  bottom: var(--footerBottom);
  transition: height 0.2s;
/*   border: 2px solid red; */
}

.footerInfo {
  display: flex;
/*  border-width: 5px;
  border-style: double;
  border-top: none;
  border-radius: 0 0 20pt 20pt; */
  text-align: center;
  justify-content: center;
  margin: 0 auto;
  max-width:680px;
}

.footerInfoSection {
  flex: 1 1 auto;
  min-width: 0;
/*   min-width: 50px;
/*   display: inline-block; */
  border: none;
  border-radius: 0;
  font-size: 10pt;
  filter: opacity(95%);
}

.footerInfoSection img {
  height: 12pt;
  vertical-align: text-top;
    justify-content: center;
  align-items: center;
  align-self: center;
  align-content: center;
}

@media (max-width: 768px) {
  .footer {
    height: var(--footerMobileHeight);
  }

  .footerInfoSection span {
    display: none;
  }

}

</style>